<template>
<div class="modal-parametros">
  <div class="header">
    <div class="close">
      <v-icon @click="returnScreen()" color="white">mdi-close</v-icon>
    </div>
    <!-- <div class="add">
      <v-icon @click="returnScreen()" color="white">mdi-plus</v-icon>
    </div> -->
    <h2>Clientes cadastrados</h2>
  </div>
  <div class="body">
    <v-text-field v-model="search.term" v-debounce:1s="getClients" :disabled="loading" class="mt-2" color="#777" label="Buscar Cliente" clearable outlined hide-details></v-text-field>
    <div style="overflow: hidden; margin: 10px 0;">
      <div class="total-items" style="float: left;">Total: {{ !loading ? list.total : '...' }}</div>
      <v-select v-model="search.order" :items="order_list" :disabled="loading" color="#777" hide-details outlined dense style="float: right; width: calc(100% - 130px); margin-left: 10px;"></v-select>
    </div>
    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        height="71"
        type="image"
        style="margin-bottom: 10px;"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="mx-auto"
        height="71"
        type="image"
        style="margin-bottom: 10px;"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="mx-auto"
        height="71"
        type="image"
        style="margin-bottom: 10px;"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <div v-if="list.items.length > 0" class="client-list">
        <div v-for="client in list.items" :key="client.id" @click="editClient(client)" class="client">
          <div class="name">{{ client.name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) }}</div>
          <div class="last-activity">
            <b style="color: #70757a">{{ client.service_orders_count }} Serviços</b>  ⸱ Último serviço em <b v-if="client.service_orders_last">{{ new Date(client.service_orders_last).toLocaleDateString() }}</b> <b v-else>--</b>
          </div>
        </div>
      </div>
      <div v-else>
        <p>Sem clientes cadastrados até o momento</p>
      </div>
    </div>
    <ClientsForm
      v-if="client_dialog.status"
      :dialog="client_dialog"
      @return="closeClientDialog"
    />
  </div>
</div>
</template>

<script>
import ClientsForm from './Forms/ClientForm';

export default {
  name: 'Clients',
  components: {
    ClientsForm,
  },
  data: () => ({
    loading: true,
    order_list: [
      {
        text: 'Último serviço',
        value: 'service_orders_last',
      },
      {
        text: 'Quantidade Serviços',
        value: 'service_orders_count',
      }
    ],
    search: {
      term: '',
      order: 'service_orders_last',
      page: 1,
      total_pages: null,
    },
    list: {
      total: 0,
      items: [],
    },
    client_dialog: {
      status: false,
      client: null,
    }
  }),
  mounted() {
    this.getClients();
  },
  methods: {
    getClients(reset = false) {
      const self = this;
      self.loading = true;
      self.$http.get('/clients', {
        params: {
          name: self.search.term,
          order: self.search.order,
          page: self.search.page,
          size: 10,
        },
      }).then((response) => {
        self.list.total = response.data.totalItems;
        if (reset) {
          self.list.items = response.data.rows;
          self.search.page = 1;
        } else {
          self.list.items = self.list.items.concat(response.data.rows);
        }
        self.loading = false;
      }).catch(() => {
        self.loading = false;
      });
    },
    editClient(client) {
      this.client_dialog = {
        status: true,
        client
      };
    },
    closeClientDialog(client) {
      this.client_dialog.status = false;
      const clientIndex = this.list.items.findIndex(c => c.id === client.id);
      this.list.items[clientIndex] = client;
    },
    returnScreen() {
      this.$emit('return');
    },
  },
  watch: {
    'search.term': {
      handler(val) {
        if (!val || val.length === 0) {
          this.getClients(true);
        }
      },
    },
    'search.order': {
      handler() {
        this.getClients(true);
      },
    },
  },
};
</script>

<style lang="scss">
.client-list {

  .client {
    border: 1px solid #a8a8a8;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;

    .name {
      font-weight: 400;
      font-size: 20px;
      padding-left: 5px;
    }

    .last-activity {
      color: #4d5156;
      font-size: 13px;
      padding-left: 5px;
    }

  }

}

// .v-progress-circular {
//   position: fixed;
//   left: 50%;
//   top: 50%;
//   -webkit-transform: translate(-50%, -50%);
//   transform: translate(-50%, -50%);
// }
</style>
